module.exports = __webpack_public_path__ + "img/top_bg.65c5ca25.png";